/**
 * Created by Ning Jiang on 2021-06-21.
 */

import {DeadwoodRipGameAssets} from "../../../DeadwoodRipGameAssets";
import {DeadwoodRip} from "../../../DeadwoodRip";

export class WaysWonTextContainer extends PIXI.Container {

    private readonly _wayWonTextures:string[] = ["wayWon", "waysWon"];

    private _waysWonNumber:PIXI.BitmapText;
    private _waysWonText:PIXI.Sprite;

    constructor() {
        super();

        this._waysWonText = new PIXI.Sprite();
        this._waysWonText.anchor.set(1, 0.5);
        this._waysWonText.scale.set(0.6);
        this.addChild(this._waysWonText);

        this._waysWonNumber = new PIXI.BitmapText("", {
            fontName : DeadwoodRipGameAssets.BITMAP_FONT_WAYS_COUNT_UP,
            fontSize : 28,
            tint : 0xffffff
        });
        (<PIXI.Point>this._waysWonNumber.anchor).set(0, 1.5);
        this._waysWonNumber.letterSpacing = -34;
        this.addChild(this._waysWonNumber);
    }

    public show(winWaysWon:number):void {
        this._waysWonNumber.text = "" + winWaysWon;
        // this._waysWonNumber.text = "18" ;
        const textureName:string = winWaysWon === 1 ? this._wayWonTextures[0] : this._wayWonTextures[1];
        this._waysWonText.texture = DeadwoodRip.assetLoader.getTextures(`initialwin/ways/${textureName}`)[0];
        this.updatePositions();
    }

    private updatePositions():void {
        const space = -22;
        this._waysWonNumber.updateTransform();
        const totalWidth:number = this._waysWonNumber.width + this._waysWonText.width + space;
        this._waysWonNumber.x = -totalWidth / 2;
        this._waysWonText.x = totalWidth / 2;
    }

    public setColor(color:number):void {
        this._waysWonNumber.tint = color;
        this._waysWonText.tint = color;
    }
}